import React from 'react';

export const NoConnectionIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '40'}
    height={props?.height || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66669 1.66669L38.3334 38.3334M27.8667 18.4334C29.2319 19.0996 30.5084 19.9338 31.6667 20.9167M8.33335 20.9167C10.8035 18.8514 13.7765 17.477 16.95 16.9334M17.85 8.41669C21.4207 8.12897 25.0128 8.56363 28.4118 9.69472C31.8108 10.8258 34.947 12.6301 37.6334 15M2.36669 15C4.67863 12.9564 7.32952 11.3321 10.2 10.2M14.2167 26.85C15.9087 25.6479 17.9328 25.0021 20.0084 25.0021C22.0839 25.0021 24.108 25.6479 25.8 26.85M20 33.3334H20.0167"
      stroke={props.color || '#B42318'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
